/**
 * Takes any import runs `Number(input)` returns the number or 0 if NaN
 *
 * @param {any} input
 * @returns {number}
 */
export const toNumber = input => {
  const num = Number(input)
  return isNaN(num) ? 0 : num
}

/**
 * @param {any} num
 * @param {number} [decimals] Max number of decimals
 * @returns
 */
export const cleanUpRound = (num, decimals = 3) =>
  Number(toNumber(num).toFixed(decimals))

/**
 * Gets average value of an array. Tries to convert each entry to a number. So
 * any non-numerical item will be averaged in as a zero.
 *
 * @param {any[]} arr
 * @param {number} [decimals]
 * @returns Number
 */
export const getAverage = (arr, decimals = 1) => {
  if (!arr || !arr.length) return 0
  const total = arr.reduce((total, num) => total + toNumber(num), 0)
  return total ? cleanUpRound(total / arr.length, decimals) : 0
}
